module.exports = __webpack_public_path__ + "static/media/fleetlocate-google-play.b2f7755e.png";